import { BASE_52_DIGITS, generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

const BASE_36_DIGITS = '0123456789abcdefghijklmnopqrstuvwxyz';

// The integer-part head alphabet. v3 hard-coded the head markers to A-Z/a-z
// regardless of the digit alphabet; v4 made them configurable via `intDigits`
// (defaulting to `digits`). Passing BASE_52_DIGITS (A-Z + a-z) keeps v4's output
// byte-identical to the v3 base-36 keys already persisted in `field meta.sort`,
// so the upgrade needs no data migration and existing keys stay valid.
const INT_DIGITS = BASE_52_DIGITS;

export function generateSortKey(before: string | null, after: string | null): string {
	return generateKeyBetween(before, after, BASE_36_DIGITS, INT_DIGITS);
}

export function generateSortKeys(before: string | null, after: string | null, count: number): string[] {
	return generateNKeysBetween(before, after, count, BASE_36_DIGITS, INT_DIGITS);
}

/**
 * Compare two fractional-index sort keys.
 *
 * `fractional-indexing` keys must be compared by raw byte (code-unit) order: the library
 * encodes positions before "a0" with an uppercase prefix (e.g. "Zz"), and uppercase sorts
 * before lowercase in ASCII. `localeCompare` collates case-insensitively and breaks this
 * contract, so always compare keys with this helper.
 */
export function compareSortKeys(a: string, b: string): number {
	if (a < b) return -1;
	if (a > b) return 1;
	return 0;
}
